"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "d-flex flex-gap" };
const _hoisted_2 = { class: "form-radio form-inline" };
const _hoisted_3 = ["value", "checked"];
const _hoisted_4 = { class: "form-radio form-inline" };
const _hoisted_5 = ["value", "checked", "disabled"];
const _hoisted_6 = {
    key: 0,
    class: "relative"
};
const _hoisted_7 = { class: "form-group d-flex flex-gap flex-align-center flex-justify-between flex-wrap" };
const _hoisted_8 = { class: "d-flex flex-align-center flex-wrap" };
const _hoisted_9 = { class: "d-flex" };
const _hoisted_10 = { class: "form-radio form-inline ml-2" };
const _hoisted_11 = { class: "form-radio form-inline" };
const _hoisted_12 = {
    key: 0,
    class: "d-flex"
};
const _hoisted_13 = { class: "form-group d-flex flex-gap mt-2 flex-align-center flex-wrap" };
const _hoisted_14 = { class: "d-flex flex-wrap ml-2" };
const _hoisted_15 = { class: "form-radio form-inline" };
const _hoisted_16 = ["checked"];
const _hoisted_17 = { class: "form-radio form-inline" };
const _hoisted_18 = ["checked"];
const _hoisted_19 = {
    class: "oplus-form-checkbox m-1",
    for: "evenly"
};
const _hoisted_20 = ["checked"];
const _hoisted_21 = {
    class: "oplus-form-checkbox m-1",
    for: "work-evenly"
};
const _hoisted_22 = ["checked"];
const RoleRequiredCalendar_vue_1 = __importDefault(require("../../roleRequiredCalendar/RoleRequiredCalendar.vue"));
const RoleRequiredByDay_vue_1 = __importDefault(require("./RoleRequiredByDay.vue"));
const RoleRequiredByStaff_vue_1 = __importDefault(require("./RoleRequiredByStaff.vue"));
const RoleRequiredWeekly_vue_1 = __importDefault(require("./RoleRequiredWeekly.vue"));
const vue_3 = require("vue");
const roleRequest_1 = require("../../requests/roleRequest");
const common_1 = require("../../common/common");
const timeZones_1 = __importDefault(require("../../common/timeZones"));
const rolesStaffTableTypes_1 = require("../../vue/rolesStaffView/rolesStaffTableTypes");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleRequiredWrapper',
    props: {
        hasAutoPerm: Boolean,
    },
    emits: ["change"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const originalRole = (0, vue_3.inject)("roleView");
        const originalRequiredMap = (0, vue_3.inject)("roleRequiredMap");
        const activeUserData = (0, vue_3.inject)("activeUserData");
        const emit = __emit;
        const roleRequiredType = (0, vue_3.computed)(() => {
            return role.value.type ?? rolesStaffTableTypes_1.ROLE_TYPE_INDEX.BY_DAYS;
        });
        const role = (0, vue_3.ref)(cloneRole(originalRole?.value));
        const roleRequiredMap = (0, vue_3.ref)(cloneRequiredMap(originalRequiredMap?.value));
        const weekDayRequired = (0, vue_3.computed)(() => {
            return role.value.requiredWeekdayNumbers ?? [];
        });
        const roleDaysReqSettings = (0, vue_3.ref)(0);
        const settingsResetKey = (0, vue_3.ref)(0);
        function markSettingsChanged() {
            emit("change");
        }
        function cloneRole(role) {
            return structuredClone((0, vue_3.toRaw)(role ?? {
                id: 0,
                name: '',
                requiredWeekdayNumbers: [0, 0, 0, 0, 0, 0, 0, ''],
                employeesData: [],
                employeesOrder: [],
            }));
        }
        function cloneRequiredMap(requiredMap) {
            return structuredClone((0, vue_3.toRaw)(requiredMap ?? {}));
        }
        function handleSettingsInput(event) {
            const target = event.target;
            if (!target.closest("[data-ignore-unsaved-changes]")) {
                markSettingsChanged();
            }
        }
        (0, vue_3.provide)("roleView", role);
        (0, vue_3.provide)("roleRequiredMap", roleRequiredMap);
        (0, vue_3.provide)("weekDayRequired", weekDayRequired);
        (0, vue_3.provide)("markRoleRequiredChanged", markSettingsChanged);
        function handleEmpPriorityChange(value) {
            role.value.employeePriority = value;
        }
        function handleEvenlyChange(e) {
            const target = e.target;
            role.value.evenly = target.checked;
        }
        function handleWorkEvenlyChange(e) {
            const target = e.target;
            role.value.workEvenly = target.checked;
        }
        function handleTypeChange(type) {
            role.value.type = type;
            if (type !== rolesStaffTableTypes_1.ROLE_TYPE_INDEX.BY_DAYS) {
                return;
            }
            const employeeIds = new Set(role.value.employeesOrder ?? []);
            role.value.employeesData?.forEach(employee => {
                employee.joined = employeeIds.has(employee.id);
            });
        }
        (0, vue_3.watch)(() => originalRole?.value.type, type => {
            if (type !== undefined) {
                handleTypeChange(type);
            }
        });
        (0, vue_3.watch)(() => originalRequiredMap?.value, requiredMap => {
            roleRequiredMap.value = cloneRequiredMap(requiredMap);
        });
        function getOverrideDates() {
            return Object.fromEntries(Object.values(roleRequiredMap.value).map(value => [
                (0, common_1.yearMonthDateString)(value.realDate, timeZones_1.default.ASIA_TOKYO),
                value.required,
            ]));
        }
        async function saveChanges() {
            if (!originalRole?.value || !activeUserData) {
                return false;
            }
            const employees = role.value.employeesData ?? [];
            const employeeIds = role.value.employeesOrder ?? [];
            await (0, roleRequest_1.updateRoleAssignmentSettings)(activeUserData.branchId, activeUserData.userId, role.value.id, {
                type: role.value.type ?? rolesStaffTableTypes_1.ROLE_TYPE_INDEX.BY_DAYS,
                dayNumbers: (role.value.requiredWeekdayNumbers ?? [0, 0, 0, 0, 0, 0, 0, ""])
                    .map(value => value === "" ? -1 : Number(value)),
                employeePriority: role.value.employeePriority ?? 1,
                employeeIds,
                employeeCounts: employees.map(employee => ({
                    ID: employee.id,
                    Week: employee.weekly,
                    Month: employee.monthly,
                })),
                overrideDates: getOverrideDates(),
                evenly: Boolean(role.value.evenly),
                workEvenly: Boolean(role.value.workEvenly),
            });
            const savedRole = cloneRole(role.value);
            Object.assign(originalRole.value, {
                type: savedRole.type,
                requiredWeekdayNumbers: savedRole.requiredWeekdayNumbers,
                employeePriority: savedRole.employeePriority,
                employeesData: savedRole.employeesData,
                employeesOrder: savedRole.employeesOrder,
                evenly: savedRole.evenly,
                workEvenly: savedRole.workEvenly,
            });
            if (originalRequiredMap) {
                originalRequiredMap.value = cloneRequiredMap(roleRequiredMap.value);
            }
            return true;
        }
        function clearChanges() {
            role.value = cloneRole(originalRole?.value);
            roleRequiredMap.value = cloneRequiredMap(originalRequiredMap?.value);
            roleDaysReqSettings.value = 0;
            settingsResetKey.value += 1;
        }
        __expose({ saveChanges, clearChanges });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                key: settingsResetKey.value,
                onInputCapture: handleSettingsInput,
                onChangeCapture: handleSettingsInput
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createCommentVNode)(" Radio for now, in the future it will be change to checkbox "),
                    (0, vue_2.createElementVNode)("label", _hoisted_2, [
                        (0, vue_2.createElementVNode)("input", {
                            type: "radio",
                            name: "role-type-settings",
                            value: (0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_INDEX).BY_DAYS,
                            onChange: _cache[0] || (_cache[0] = ($event) => (handleTypeChange((0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_INDEX).BY_DAYS))),
                            checked: role.value.type === (0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_INDEX).BY_DAYS
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3),
                        _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* CACHED */)),
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_TEXT)[(0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_INDEX).BY_DAYS]), 1 /* TEXT */)
                    ]),
                    (0, vue_2.createElementVNode)("label", _hoisted_4, [
                        (0, vue_2.createElementVNode)("input", {
                            type: "radio",
                            name: "role-type-settings",
                            value: (0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_INDEX).EMPLOYEE_COUNT,
                            onChange: _cache[1] || (_cache[1] = ($event) => (handleTypeChange((0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_INDEX).EMPLOYEE_COUNT))),
                            checked: role.value.type === (0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_INDEX).EMPLOYEE_COUNT,
                            disabled: !__props.hasAutoPerm
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5),
                        _cache[9] || (_cache[9] = (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* CACHED */)),
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_TEXT)[(0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_INDEX).EMPLOYEE_COUNT]), 1 /* TEXT */)
                    ])
                ]),
                _cache[23] || (_cache[23] = (0, vue_2.createElementVNode)("div", { class: "role-required-divider" }, null, -1 /* CACHED */)),
                (roleRequiredType.value === (0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_INDEX).BY_DAYS)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                        (0, vue_2.createElementVNode)("div", _hoisted_7, [
                            (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                _cache[14] || (_cache[14] = (0, vue_2.createElementVNode)("span", { class: "h5 mr-2" }, "必要人数", -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_10, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            type: "radio",
                                            name: "role-days-settings",
                                            value: 0,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((roleDaysReqSettings).value = $event)),
                                            "data-ignore-unsaved-changes": ""
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, roleDaysReqSettings.value]
                                        ]),
                                        _cache[10] || (_cache[10] = (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* CACHED */)),
                                        _cache[11] || (_cache[11] = (0, vue_2.createTextVNode)(" 設定 ", -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_11, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            type: "radio",
                                            name: "role-days-settings",
                                            value: 1,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((roleDaysReqSettings).value = $event)),
                                            "data-ignore-unsaved-changes": ""
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, roleDaysReqSettings.value]
                                        ]),
                                        _cache[12] || (_cache[12] = (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* CACHED */)),
                                        _cache[13] || (_cache[13] = (0, vue_2.createTextVNode)(" 上書き ", -1 /* CACHED */))
                                    ])
                                ])
                            ]),
                            (roleDaysReqSettings.value === 1)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_12, [
                                    (0, vue_2.createCommentVNode)(" ToDO: refactor these buttons as well "),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-secondary",
                                        onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.showDashModal(true, 'role-csv')))
                                    }, "インポート"),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-secondary",
                                        onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.outputRoleCSV()))
                                    }, "ダウンロード")
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ]),
                        (0, vue_2.createCommentVNode)(" Settings type 0 (設定)"),
                        (roleDaysReqSettings.value === 0)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(RoleRequiredWeekly_vue_1.default, { key: 0 }))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                                (0, vue_2.createCommentVNode)(" Settings type 1 (上書き) "),
                                (0, vue_2.createVNode)(RoleRequiredCalendar_vue_1.default)
                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                        (0, vue_2.createElementVNode)("div", _hoisted_13, [
                            _cache[21] || (_cache[21] = (0, vue_2.createElementVNode)("span", { class: "h5 mr-2" }, "配置スタッフ", -1 /* CACHED */)),
                            (0, vue_2.createElementVNode)("div", _hoisted_14, [
                                (0, vue_2.createElementVNode)("label", _hoisted_15, [
                                    (0, vue_2.createElementVNode)("input", {
                                        type: "radio",
                                        name: "employee-priority-settings",
                                        checked: role.value.employeePriority === 0,
                                        onChange: _cache[6] || (_cache[6] = ($event) => (handleEmpPriorityChange(0)))
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_16),
                                    _cache[15] || (_cache[15] = (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* CACHED */)),
                                    _cache[16] || (_cache[16] = (0, vue_2.createTextVNode)(" 上優先 ", -1 /* CACHED */))
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_17, [
                                    (0, vue_2.createElementVNode)("input", {
                                        type: "radio",
                                        name: "employee-priority-settings",
                                        checked: role.value.employeePriority === 1,
                                        onChange: _cache[7] || (_cache[7] = ($event) => (handleEmpPriorityChange(1)))
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_18),
                                    _cache[17] || (_cache[17] = (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* CACHED */)),
                                    _cache[18] || (_cache[18] = (0, vue_2.createTextVNode)(" ランダム ", -1 /* CACHED */))
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_19, [
                                    _cache[19] || (_cache[19] = (0, vue_2.createTextVNode)(" 均等に ", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("input", {
                                        id: "evenly",
                                        onChange: handleEvenlyChange,
                                        checked: role.value.evenly,
                                        type: "checkbox"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_20)
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_21, [
                                    _cache[20] || (_cache[20] = (0, vue_2.createTextVNode)(" 出勤数順 ", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("input", {
                                        id: "work-evenly",
                                        onChange: handleWorkEvenlyChange,
                                        checked: role.value.workEvenly,
                                        type: "checkbox"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_22)
                                ])
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" Staff list "),
                        (0, vue_2.createVNode)(RoleRequiredByDay_vue_1.default)
                    ]))
                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                        (0, vue_2.createCommentVNode)(" Role Type 1 "),
                        (0, vue_2.createElementVNode)("div", null, [
                            (0, vue_2.createCommentVNode)(" Staff list "),
                            (0, vue_2.createElementVNode)("div", null, [
                                _cache[22] || (_cache[22] = (0, vue_2.createElementVNode)("span", { class: "h5 mr-2" }, "配置スタッフ", -1 /* CACHED */)),
                                (0, vue_2.createVNode)(RoleRequiredByStaff_vue_1.default)
                            ])
                        ])
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            ], 32 /* NEED_HYDRATION */));
        };
    }
});
